import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import { StyledTier, TierSelected } from './FeatureStyledComponents';

const FeaturesMobileTierPicker = ({
  activeColumn,
  headerKeys,
  setActiveColumn
}) => /*#__PURE__*/_jsxs(StyledTier, {
  children: [/*#__PURE__*/_jsx("input", {
    type: "checkbox",
    id: "tierToggle"
  }), /*#__PURE__*/_jsx(TierSelected, {
    htmlFor: "tierToggle",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `upgrades.productCatalog.tableHeader.${headerKeys.slice(1)[activeColumn]}`
    })
  }), /*#__PURE__*/_jsx(UIIcon, {
    name: "downCarat",
    size: 12
  }), /*#__PURE__*/_jsx("ul", {
    children: headerKeys.slice(1).map((headerKey, i) => /*#__PURE__*/_jsx("li", {
      onClick: () => setActiveColumn(i),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `upgrades.productCatalog.tableHeader.${headerKey}`
      })
    }, i))
  })]
});

export default FeaturesMobileTierPicker;